import { Toaster } from "sonner";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  Info,
  XCircle,
  CheckCircle,
  WarningCircle,
} from "@phosphor-icons/react";
import { Suspense, lazy } from "react";
import LoadingSpinner from "components/app/LoadingSpinner";
import Footer from "components/footer";
import { useScrollToTop } from "./hooks/useScrollToTop";

const Home = lazy(() => import("pages/home"));
const ProfilePage = lazy(() => import("pages/profile"));
const CreateToken = lazy(() => import("pages/create-token"));
const TokenDetails = lazy(() => import("pages/token-details"));
const PrivacyPolicy = lazy(() => import("pages/privacy"));
const Topbar = lazy(() => import("components/topbar"));
const TokenTicker = lazy(() => import("components/token-ticker/token-ticker"));
const CreatorClaims = lazy(() => import("pages/creator-claims"));

function App() {
  // Enable scroll to top for token pages and create token page
  useScrollToTop();

  return (
    <>
      <main className="">
        <div className="page-container">
          <div className="page-container__content">
            <Suspense fallback={<LoadingSpinner />}>
              <Topbar />
            </Suspense>

            <Suspense fallback={null}>
              <TokenTicker />
            </Suspense>

            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/coin" element={<Navigate to="/" replace />} />
                <Route path="/create" element={<CreateToken />} />
                <Route path="/creator-claims" element={<CreatorClaims />} />
                <Route path="/profile/:userAddress" element={<ProfilePage />} />
                <Route path="/coin/:contractAddress" element={<TokenDetails />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
              </Routes>
            </Suspense>

            <Suspense fallback={<LoadingSpinner />}>
              <Footer />
            </Suspense>
          </div>
        </div>
      </main>

      <Toaster
        theme="light"
        duration={2500}
        position="top-center"
        className="toast-block"
        icons={{
          info: <Info size={16} weight="fill" color="#eba267" />,
          error: <XCircle size={16} weight="fill" color="#ff5c5c" />,
          success: <CheckCircle size={18} weight="fill" color="#16f19d" />,
          warning: <WarningCircle size={16} weight="fill" color="#eba267" />,
        }}
      />
    </>
  );
}

export default App;
